import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@mui/material';

interface Step4FormProps {
  formData: { [key: string]: any };
}

const labelMap: { [key: string]: string } = {
  name: 'Nama',
  phone: 'No WA #1',
  phone2: 'No WA #2',
  kecamatan: 'Kecamatan',
  address: 'Alamat',
  dateEvent: 'Tanggal Acara',
  timeEvent: 'Waktu Acara',
  timeArrive: 'Waktu Kedatangan',
  niat: 'Peniatan',
  nameNiat: 'Nama Peniatan',
  namaPanggilan: 'Nama Panggilan',
  birth_place: 'Tempat, Tanggal Lahir',
  data_kartu: 'Data Kartu Ucapan',
  paket_katalog: 'Pilihan Paket Katalog',
  paket_catering: 'Pilihan Paket Catering',
  pilih_kambing: 'Pilihan Kambing',
  jumlah_daging: 'Jumlah Potong Daging',
  masakan_daging: 'Masakan Daging',
  selectedVegetables: 'Pilihan Sayur',
  package_rice: 'Jenis Nasi',
  amount_rice: 'Jumlah Box',
  kkj : 'Kepala Kaki Jeroan (KKJ)',
  kulit: 'Kulit',
  menu_kulit: 'Menu Kulit',
  jumlah_kulit_dimasak: 'Jumlah Kulit Dimasak',
  penyembelihan: 'Penyembelihan',
  souvenir: 'Souvenir',
  kartu: 'Pilihan Kartu',
  amount_box_catering: 'Jumlah Box',
  jumlah_ekor: 'Jumlah Ekor',
  pakai_jantan: 'Pakai Jantan',
  jumlah_jantan: 'Jumlah Jantan',
  sisa_daging: 'Sisa Daging',
  pakaiFoto: 'Pakai Foto', // Tambahkan label baru di sini

};

const orderAqiqah = [
  'name', 'phone', 'phone2', 'kecamatan', 'address', // step 1
  'niat', 'nameNiat', 'namaPanggilan' ,'birth_place','dateEvent', 'timeEvent', 'timeArrive', //step 2
  'paket_katalog', 'paket_catering', 'package_rice', 'amount_rice', //step3
  'pilih_kambing','jumlah_daging','jumlah_ekor', 'jumlah_jantan','sisa_daging','masakan_daging', //step4
  'kkj','selectedVegetables',  //step 5
  'kulit', 'menu_kulit', 'jumlah_kulit_dimasak', //step 6
  'penyembelihan', //step 7
  'souvenir', 'kartu','pakaiFoto', 'data_kartu', //step 8
];

const orderPeringatan = [
  'name', 'phone', 'phone2', 'kecamatan', 'address',
  'niat', 'nameNiat', 'dateEvent', 'timeEvent', 'timeArrive',
  'paket_katalog', 'paket_catering', 'amount_box_catering', 'souvenir', 'kartu', 'data_kartu'
];

const Step4Form: React.FC<Step4FormProps> = ({ formData }) => {
    const formatValue = (key: string, value: any) => {
        if (key === 'selectedVegetables' && Array.isArray(value)) {
          return value.map(item => item?.title || '-').join(', ');
        }
        if (Array.isArray(value)) {
          return value.map(item => (typeof item === 'object' ? item.label || JSON.stringify(item) : item)).join(', ');
        }
        if (key === 'dateEvent' && value) {
          const [year, month, day] = value.split('-'); // misalnya 2025-04-08
          return `${day}/${month}/${year}`;
        }
        if (key === 'pakai_jantan') {
          return value ? 'Ya' : 'Tidak';
        }
      

        return value ? value.toString() : '-';
      };

      const selectedOrder = formData.pilih_paket === 'kambing' ? orderAqiqah : orderPeringatan;
      const optionalFields = ['dateEvent', 'timeEvent', 'timeArrive', 'nameNiat'];

        
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Ringkasan
      </Typography>
      <Typography variant="body2" gutterBottom>
        Pastikan semua informasi sudah benar sebelum submit data.
      </Typography>

      <List>
      {selectedOrder.map((key) => {
        if (
          key === 'sisa_daging' &&
          (formData.paket_katalog?.trim() === 'Sate A' || formData.paket_katalog?.trim() === 'Sate B')
        ) {
          return null;
        }

        const value = formData[key];
        let formatted = formatValue(key, value);

        if (
          (!formatted || formatted === '-' || formatted.trim() === '') &&
          optionalFields.includes(key)
        ) {
          formatted = 'isi data menyusul';
        }

        if (!formatted || formatted === '-' || formatted.trim() === '') return null;

        return (
          <ListItem key={key} divider>
            <ListItemText
              primary={
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {labelMap[key] || key}
                </Typography>
              }
              secondary={formatted}
            />
          </ListItem>
        );
      })}
    </List>

    </div>
  );
};

export default Step4Form;
